import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Provider } from "react-redux";
import { store } from "./store";
import { LoadScript } from "@react-google-maps/api";
import "./index.css";

const renderApp = (Component, rootElement) => {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <Provider store={store}>
      <Component />
    </Provider>
  );
};

const rootElement = document.getElementById("fz-detail-root");

if (window.google) {
  // Google Maps API is already loaded
  renderApp(App, rootElement);
} else {
  // Google Maps API is not loaded, use LoadScript to load it
  const loadScriptElement = (
    <LoadScript
      googleMapsApiKey={process.env.REACT_APP_GOOGLE_API_KEY}
      libraries={["places"]}
    >
      <App />
    </LoadScript>
  );

  const root = ReactDOM.createRoot(rootElement);
  root.render(<Provider store={store}>{loadScriptElement}</Provider>);
}
